import * as React from 'react';

const InstructIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="instruct-illustration"
    >
      <mask
        id="instruct-mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="5"
        width="24"
        height="22"
      >
        <path
          d="M4 12.4444C4 10.7911 4 9.96444 4.18173 9.28622C4.67489 7.44573 6.11247 6.00814 7.95296 5.51498C8.63119 5.33325 9.45783 5.33325 11.1111 5.33325H15.2C19.6804 5.33325 21.9206 5.33325 23.6319 6.2052C25.1372 6.97219 26.3611 8.19603 27.1281 9.70133C28 11.4126 28 13.6528 28 18.1333V18.6666C28 21.1516 28 22.3941 27.594 23.3742C27.0527 24.681 26.0145 25.7193 24.7076 26.2606C23.7275 26.6666 22.485 26.6666 20 26.6666H18.2222C14.9157 26.6666 13.2624 26.6666 11.9059 26.3031C8.22495 25.3168 5.34977 22.4416 4.36346 18.7607C4 17.4042 4 15.7509 4 12.4444Z"
          fill="#FF0000"
        />
      </mask>
      <g mask="url(#instruct-mask0)">
        <rect width="32" height="32" rx="2" fill="url(#instruct-gradient0)" />
      </g>
      <path
        d="M12.0001 21.3334C14.2092 21.3334 16.0001 23.1242 16.0001 25.3334V26.6667C16.0001 28.1395 14.8062 29.3334 13.3334 29.3334H5.33341C3.86066 29.3334 2.66675 28.1395 2.66675 26.6667V25.3334C2.66675 23.1242 4.45761 21.3334 6.66675 21.3334H12.0001Z"
        fill="#86321F"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M9.33341 11.3334C11.5426 11.3334 13.3334 13.1242 13.3334 15.3334C13.3334 17.5425 11.5426 19.3334 9.33341 19.3334C7.12428 19.3334 5.33341 17.5425 5.33341 15.3334C5.33341 13.1242 7.12428 11.3334 9.33341 11.3334Z"
        fill="#86321F"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0001 3.33337H17.3334C15.8607 3.33337 14.6667 4.52728 14.6667 6.00004C14.6667 7.4728 15.8607 8.66671 17.3334 8.66671H28.0001C29.4728 8.66671 30.6667 7.4728 30.6667 6.00004C30.6667 4.52728 29.4728 3.33337 28.0001 3.33337ZM28.0001 10.6667H20.6667C19.194 10.6667 18.0001 11.8606 18.0001 13.3334C18.0001 14.8061 19.194 16 20.6667 16H28.0001C29.4728 16 30.6667 14.8061 30.6667 13.3334C30.6667 11.8606 29.4728 10.6667 28.0001 10.6667Z"
        fill="#FCD3C9"
        style={{ mixBlendMode: 'multiply' }}
      />
      <defs>
        <linearGradient
          id="instruct-gradient0"
          x1="16"
          y1="-6"
          x2="-6"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2969F2" />
          <stop offset="1" stopColor="#F55C38" />
        </linearGradient>
      </defs>
    </svg>
  );
});

InstructIllustration.displayName = 'InstructIllustration';

export { InstructIllustration };
